<template lang="pug">
  .option-wrapper
    RadioSlider.slider(
      :items="optionsData.items",
      :current="optionsData.items.findIndex(i => i.id === optionsData.selected.id)",
      @selected="onSelectOption"
    )

    template(v-if="optionsData.selected.id === 'add_autocomplete'")
      h3 Explicação
      p
        | Essa funcionalidade adiciona pontos manuais em dias onde não há marcações do {{$ws('employee')}}.
        | Com essa ferramenta você pode selecionar um período e inserir de uma forma simples e rápida pontos
        | para colaboradores que não registraram pontos em um período específico.

      p
        |  O autocompletar insere apenas informações nos dias em que não há
        |nenhuma marcação feita pelo {{$ws('employee')}}. Se o empregado registrar pelo menos 1 ponto, o
        |autocompletar não incluirá nenhuma informação. Caso haja algum erro operacional, é muito simples
        | remover os pontos: basta selecionar a opção
        strong &nbsp; deletar pontos de autocompletar no intervalo definido.

      h3 Observações
      p
        | Ao utilizar esta função, os pontos já batidos não serão alterados.
        | Indique o período em que você deseja realizar esta correção (data inicial e final) e a
        | ferramenta irá preencher os pontos conforme a jornada cadastrada do colaborador, por isso é
        | importante que se verifique se essa informação está preenchida corretamente.

      PCheckbox(label="deletar pontos de autocompletar no intervalo definido", v-model="deleteAutoComplete")

      PButton(color="success" size="md" @click="save" :loading="saving") salvar

    template(v-if="optionsData.selected.id === 'faketimelog'")
      PSelect(v-model="ptKind" title="tipo do ponto" labelItem="name" :allowEmpty="false")

      Validate(v-model="ptReason")
        PSelect(title="motivo da correção" labelItem="description" useCommon="reasons/onlyForFakePts"
          :allowEmpty="false")

      PTimeField(v-model="ptTime" :showPlusOneDay="ptKind.selected.id !== 'Entrada'" name="ptTime" :baseDate="new Date()" label="")

      PCheckbox(label="+1d", v-model="plusOneDay")

      PButton(color="success" size="md" @click="save" :loading="saving") salvar

    template(v-if="optionsData.selected.id === 'delete_faketimelog'")
      PButton(color="success" size="md" @click="save" :loading="saving") apagar pontos do autocompletar

    template(v-if="optionsData.selected.id === 'delete_all_faketimelogs'")
      PButton(color="success" size="md" @click="save" :loading="saving") apagar todos os pontos manuais

</template>

<script>
import { useValidationsMixin } from 'src/common/validations'
import {formatDateToSend} from 'src/utils'
import moment from 'moment'

export default {
  name: 'Pontos',
  mixins: [useValidationsMixin({deepCheck: false})],
  props: {
    saveParams: {type: Object, required: true},
    options: {type: Array, required: true}
  },
  created () {
    this.optionsData.items = this.options
    this.optionsData.selected = this.options[0]
  },
  data () {
    return {
      saving: false,
      optionsData: {
        selected: null,
        items: []
      },
      ptKind: {
        loaded: [
          {name: 'Entrada', id: 'Entrada'},
          {name: 'Pausa', id: 'Pausa'},
          {name: 'Retorno Pausa', id: 'Retorno Pausa'},
          {name: 'Saída', id: 'Saída'}
        ],
        selected: {name: 'Entrada', id: 'Entrada'}
      },
      plusOneDay: false,
      ptTime: moment().set({hour: 8, minute: 0}),
      ptReason: {
        selected: null
      },
      deleteAutoComplete: false
    }
  },
  methods: {
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }

      if (this.optionsData.selected.id === 'add_autocomplete') {
        return this.applyAutocomplete()
      }

      this.saving = true

      try {
        const result = await this.$API.fastRegister.save({
          ...this.saveParams,
          option: this.optionsData.selected.id,
          extra: this.getExtraPerOption()
        })
        this.$checkUserFiles()
        this.$swal({
          type: 'success',
          text: result.data?.success ? result.data.success : 'Mudanças aplicadas com sucesso'
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possivel aplicar as mudanças'
        })
      }

      this.saving = false
    },
    getExtraPerOption () {
      if (this.optionsData.selected.id === 'faketimelog') {
        return {
          kind: this.ptKind.selected.id,
          reason: this.ptReason.selected.description,
          time: formatDateToSend(this.ptTime),
          plusOneDay: this.plusOneDay
        }
      } else {
        return {}
      }
    },
    onSelectOption (item) {
      this.optionsData.selected = item
    },
    async applyAutocomplete () {
      this.saving = true

      try {
        const result = await this.$API.autoComplete.save({
          employees: this.saveParams.employees,
          companies: this.saveParams.companies,
          employer: this.saveParams.employer,
          dateStart: this.saveParams.startDate,
          dateEnd: this.saveParams.endDate,
          delete: this.deleteAutoComplete
        })
        this.$checkUserFiles()
        this.$swal({
          type: 'success',
          text: result.data?.success ? result.data.success : 'Mudanças aplicadas com sucesso'
        })
      } catch (e) {
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : 'Não foi possivel aplicar as mudanças'
        })
      }

      this.saving = false
    }
  }
}
</script>

<style scoped lang="scss">
.option-wrapper {
  display: grid;
  grid-row-gap: 10px;
  padding-top: 20px;
}
</style>
